var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icons"},React.createElement("path",{"id":"Vector","d":"M5 13.2174L9.24242 18L19 7","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"})));
}

Checkmark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
